<script>
  import { getContext, onMount, tick } from 'svelte';

  import Profile from '@utils/profile';
  import BrowserUtils from '@utils/browser-utils';
  import Text from '@components/Text.svelte';
  import PreloadBox from '@components/PreloadBox.svelte';
  import MobileOptionsModal from '@components/MobileOptionsModal.svelte';
  import UserAjax from '@ajax/user';
  import GroupCollectionAjax from '@ajax/group_collection';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import LinktreeSocial from '@app-components/profile/LinktreeSocial.svelte';

  import ProfileHeader from './components/ProfileHeader.svelte';
  import AddButton from '../profile/components/AddButton.svelte';
  import ProfileCollection from './components/ProfileCollection.svelte';
  import ProfileCollectionBar from './components/ProfileCollectionBar.svelte';
  import UserSearchBar from './components/UserSearchBar.svelte';
  import AdminInfo from './components/AdminInfo.svelte';

  import AddGroupOrIdeaModal from '@app-components/group_ideas/AddGroupOrIdeaModal.svelte';
  import CreatorSpotlightModal from '@app-components/modal/CreatorSpotlightModal.svelte';
  import CreatorScout from '@app-components/profile/CreatorScout.svelte';
  import Ambassador from '@app-components/profile/Ambassador.svelte';
  import HerCampus from '@app-components/profile/HerCampus.svelte';

  import jQuery from 'jquery';
  import { browser } from '$app/environment';
  import { getProfileStore } from '@stores/profile';
  import { getCurrentUserStore } from '@stores/current_user';
  import Track from '@utils/track';
  import { inview } from 'svelte-inview';
  import BlockedProfileContent from './BlockedProfileContent.svelte';

  let groupSortOrder = getProfileStore('groupSortOrder');
  let followCountStore = getProfileStore('followCountStore');
  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let groupCollectionSortOrderStore = getProfileStore('groupCollectionSortOrderStore');

  let allProfileGroupsLoaded = getContext('allProfileGroupsLoaded');
  let recsCount = 0;

  $: showAddBio = user.id === currentUser.id && recsCount > 2 && (user.bio == null || user.bio == '');

  $: showAddSocials = user.id === currentUser.id && recsCount > 2 && user.social_links && user.social_links.length == 0;

  $: hasGroupIdeasUser = currentUser && currentUser.has_group_possible_ideas;

  $: loading = false;

  export let user;
  let currentUser = getCurrentUserStore('default');

  let groups = groupsStore;
  let groupCollections = groupCollectionStore;
  let groupCollectionSortOrder = groupCollectionSortOrderStore;

  $: if (groupCollectionSortOrder.length > 0) {
    groupCollections = groupCollectionStore.withSortOrderUnsortedFirst(groupCollectionSortOrder.map((x) => x.value));
  } else {
    groupCollections = groupCollectionStore;
  }

  let defaultCollection = groupCollections.find((x) => x.default_collection);
  let showProfileSearchBar = user.show_search_bar;
  let showSocialLinkMenu = false;
  let showCreatorSpotlightModal = false;

  let loadingFollowers = true;

  let followInfo;

  let showAddGroupOrIdea = false;

  let followerDisabled;
  let followingDisabled;

  $: if (!currentUser.id) {
    followerDisabled =
      followInfo &&
      (followInfo.followerCount == 0 || (followInfo.followerCount < 50 && followInfo.followingCount == 0));
  } else {
    followerDisabled = followInfo && followInfo.followerCount == 0 && user.id != currentUser.id;
  }

  $: if (!currentUser.id) {
    followingDisabled = followInfo && followInfo.followingCount == 0;
  } else {
    followingDisabled = followInfo && followInfo.followingCount == 0 && user.id != currentUser.id;
  }
  let newGroupCreated = function (group, collection = defaultCollection) {
    let ids = [group.id, ...Profile.sortOrderByPageIds(collection.id)];

    groupsStore.addFront(group);
    groupSortOrder.set(ids);
    collection.set({ ...collection, group_base_sort_order: ids });
    showNewGroupAnimation(group);

    UserAjax.update(user, {
      group_base_sort_order: ids,
    });

    GroupCollectionAjax.updateSortOrder(user, [
      {
        collection_id: collection.id,
        group_ids: ids,
      },
    ]);
  };

  let endOfPageReached = function () {
    Track.profilePageEndReached({ currentUser: currentUser, user: user });
  };

  let newCollectionCreated = async function (collection) {
    await tick();

    BrowserUtils.goToElementWithScroll(jQuery(`[data-group-collection-id="${collection.id}"]`)[0]);
  };

  let showNewGroupAnimation = async function (group) {
    await tick();

    let node = jQuery(`[data-group-id=${group.id}]`);

    if (node.length > 0) {
      BrowserUtils.goToElementWithScroll(node[0], { offsetTop: -200 });
      node.addClass('new-profile-tile');
      setTimeout(function () {
        node.removeClass('new-profile-tile');
      }, 3000);
    }
  };

  let startRecommending = function () {
    showAddGroupOrIdea = true;
  };

  let followersClicked = function () {
    if (followerDisabled) {
      return;
    }
    location.href = user.profile_path + '/followers';
  };

  let followingClicked = function () {
    if (followingDisabled) {
      return;
    }
    location.href = user.profile_path + '/following';
  };

  let blockedUsers = getContext('blockedUsers');
  $: userBlocked = $blockedUsers.includes(user.id);
  $: if (userBlocked) {
    showProfileSearchBar = false;
  }

  onMount(() => {
    let unsubUser = currentUser.subscribe((x) => (currentUser = x));
    let unsubGroups = groupsStore.subscribe((x) => {
      groups = x;
      let itemCount = 0;
      groups.forEach((g) => {
        itemCount += g.items_count;
      });
      recsCount = itemCount;
    });

    let unsubFollowInfo = followCountStore.subscribe((x) => {
      followInfo = x;
      loadingFollowers = x.isNew;
    });
    let unsubCollections = groupCollectionStore.subscribe((x) => {
      if (groupCollectionSortOrderStore.length > 0) {
        groupCollections = x.withSortOrderUnsortedFirst(groupCollectionSortOrderStore.map((x) => x.value));
      } else {
        groupCollections = x;
      }
      defaultCollection = groupCollections.find((x) => x.default_collection);
    });
    return () => {
      unsubUser();
      unsubGroups();
      unsubCollections();
      unsubFollowInfo();
    };
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';
  .add-social-links {
    @include typeface-b2($font-weight-semi-bold);
    color: $purple-60;
  }

  :global(.m-lists-container) {
    :global(.owl-stage-outer) {
      overflow: unset !important;
    }
  }

  * :global(.new-profile-tile) {
    border: 2px solid #a893f9 !important;
    border-radius: 15px !important;
  }

  .user-name {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
  }

  .user-follow-count {
    color: $neutral-gray;
    margin-top: 6px;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    .count {
      font-weight: $font-weight-medium;
      color: $black;
      &.empty {
        font-weight: $font-weight-regular;
        color: $neutral-gray;
      }
    }

    span + span {
      margin-left: 12px;
    }

    .clickable {
      cursor: pointer;

      &:hover {
        color: #666;
      }
    }
  }

  .user-social-links {
    margin-top: 24px;

    .social-icons {
      a + a {
        margin-left: 7px;
        padding-left: 3px;
      }
    }
  }

  .user-creator-scout {
    margin-top: 19px;
  }

  .user-bio {
    margin-top: 19px;
    font-size: 16px;
    line-height: 22px;
    opacity: 0.5;
  }

  .panel-user-name-and-add-button {
    display: flex;
    margin-top: 20px;
    margin-bottom: 24px;

    .panel-user-name {
      flex: 1;
      min-height: 31px;

      .panel-name {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
      }

      .panel-count {
        font-size: 14px;
        line-height: 20px;
        opacity: 0.5;
        margin-left: 4px;
      }
    }

    .panel-add-button {
      margin-top: -8px;
    }
  }

  .panel-user-add-no-collections {
    margin-left: auto;
    margin-right: auto;
  }

  .loading-container {
    width: 100%;
    height: 235px;
  }

  .collection-bar-container {
    width: calc(100% + 60px);
    overflow-x: auto;
    margin-left: -30px;
    padding-left: 30px;
    margin-top: -30px;
    padding-top: 30px;
    margin-bottom: -30px;
  }

  .purple-box {
    display: flex;
    margin-top: 22px;
    border-radius: 15px;
    padding: 28px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: #f9f6ff;
    padding-top: 60px;
    padding-bottom: 60px;
    min-height: 250px;

    img {
      zoom: 0.8;
    }

    .ui-text-create {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #a893f9;
      margin-top: 15px;
    }

    .ui-text {
      line-height: 1.4;
      font-size: 16px;
      font-weight: 500;
      margin-top: 40px;
      text-align: center;
    }
  }

  .view-social-link {
    cursor: pointer;
    display: flex;
    align-items: center;
    @include typeface-h6(500);

    img {
      vertical-align: middle;
      margin-left: 10px;
    }
  }

  .creator-spotlight-button {
    background: none;
    font-weight: 500;
    border: none;
    color: #000;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: 200ms;
    padding: 0;
    margin: 16px 0;

    svg {
      margin-top: 2px;
    }
    &:hover {
      color: #a893f9;
    }
  }

  // TODO: didn't use * prefix here because it wasn't working, but have it scoped to a specific modal name
  :global(.social-links-modal .options-container .container-option) {
    border: 1px solid #ececec !important;
    border-radius: 12px !important;
    margin-bottom: 12px;
  }

  :global(.social-links-modal .options-container) {
    max-height: 375px;
    overflow-y: auto;
    // margin-bottom: 12px;
  }

  :global(.account-name-header-mobile) {
    font-size: 20px;
    font-weight: 500;
    margin-top: 0px;
    margin-bottom: 0px;
    line-height: 28px;
  }
</style>

{#if showCreatorSpotlightModal}
  <CreatorSpotlightModal
    mobile={true}
    user={user}
    clickContext={'more_about_me'}
    bind:showModal={showCreatorSpotlightModal}
    on:close={() => {
      showCreatorSpotlightModal = false;
    }} />
{/if}

{#if showAddGroupOrIdea}
  <AddGroupOrIdeaModal
    mobile={true}
    currentUser={currentUser}
    bind:showModal={showAddGroupOrIdea}
    on:create-group={() => {
      jQuery('.add-collection-btn').click();
    }} />
{/if}

{#if showSocialLinkMenu}
  <MobileOptionsModal
    bind:showModal={showSocialLinkMenu}
    class={'social-links-modal'}
    options={user.social_links.map((sl) => {
      return {
        label: sl.label,
        image: `<img style='height: 21px; width: 21px;' src='/images/profile/socials/${sl.link_type}.svg' \>`,
        fn: async () => {
          Track.profileSocialLinkClicked({
            currentUser: currentUser,
            user: user,
            path: location.pathname,
            linkDomain: sl.link_type,
            link: sl.url,
          });
          window.open(sl.url, '_blank');
        },
      };
    })}
    contentClass={'purple-scrollbar'}
    title="SOCIAL & LINKS" />
{/if}
{#if user && currentUser && currentUser.user_flag}
  <AdminInfo user_id={user.id} mobile={true} />
{/if}
<div style="padding: 0px 30px">
  <div style="margin-left: -30px; margin-right: -30px">
    <ProfileHeader user={user} mobile={true} imageSize={'small'} userBlocked={userBlocked} />
  </div>

  <div class="user-name">
    <AccountVerifiedIcon dimension={20} verified={user.verified}>
      <svelte:fragment slot="account-name">
        <Text lines={2} expand={true} text={`<h1 class='account-name-header-mobile'>${user.name}</h1>`} />
      </svelte:fragment>
    </AccountVerifiedIcon>
  </div>
  <div class="user-follow-count">
    {#if loadingFollowers || !browser}
      <div class="profile-data-placeholder" style="height: 21px" />
    {:else if followInfo}
      {#if followerDisabled && followingDisabled}
        <div class="profile-data-meta">{user.join_date}</div>
      {:else}
        <div class="profile-data-follow-count">
          <span class={followerDisabled ? '' : 'clickable'} on:click={followersClicked}>
            <a href={user.profile_path + '/followers'} class="count {followInfo.followerCount == 0 ? 'empty' : ''}"
              >{followInfo.followerCount}</a>
            follower{followInfo.followerCount != 1 ? 's' : ''}
          </span>
          <span class={followingDisabled ? '' : 'clickable'} on:click={followingClicked}>
            <a href={user.profile_path + '/following'} class="count {followInfo.followingCount == 0 ? 'empty' : ''}"
              >{followInfo.followingCount}</a>
            following
          </span>
        </div>
      {/if}
    {/if}
  </div>
  <div class="user-social-links">
    {#if showAddBio}
      <a href="/profiles/edit?show_bio=true" class="add-social-links"
        ><img
          alt="plus-icon"
          src={`/images/save-button/plus.svg`}
          style="width: 8px; height: 8px; vertical-align: middle; margin-bottom: 3px; margin-right: 3px" />Add bio</a>
    {:else if showAddSocials}
      <a href="/profiles/edit?click_social_link=true" class="add-social-links"
        ><img
          alt="plus-icon"
          src={`/images/save-button/plus.svg`}
          style="width: 8px; height: 8px; vertical-align: middle; margin-bottom: 3px; margin-right: 3px" />Add your
        socials</a>
    {:else if user.social_links && user.social_links.length > 0}
      {#if user.social_links.length > 4 || user.social_links.find((sl) => sl.link_type === 'weblink')}
        <div
          class="view-social-link"
          on:click={() => {
            showSocialLinkMenu = true;
          }}>
          <span>View social & links</span><img src="/images/profile/social-arrow.svg" alt="arrow" />
        </div>
      {:else}
        <div class="social-icons">
          {#each user.social_links as sl}
            <a
              on:click={(event) => {
                event.preventDefault();
                Track.profileSocialLinkClicked({
                  currentUser: currentUser,
                  user: user,
                  path: location.pathname,
                  linkDomain: sl.link_type,
                  link: sl.url,
                });
                window.open(sl.url);
              }}
              target="_blank"
              data-tippy-content={sl.label}
              href={sl.url}
              rel="nofollow"
              style="width: 32px; height:
      32px; padding-top: 8px;">
              <img style="height: 21px; width: 21px;" src={`/images/profile/socials/${sl.link_type}.svg`} />
            </a>
          {/each}
        </div>
      {/if}
    {/if}
    <LinktreeSocial mobile={true} />
  </div>

  {#if user.ambassador}
    <div class="user-creator-scout">
      <Ambassador mobile={true} />
    </div>
  {:else if user.her_campus}
    <div class="user-creator-scout">
      <HerCampus herCampus={user.her_campus} mobile={true} />
    </div>
  {:else if user.creator_scout}
    <div class="user-creator-scout">
      <CreatorScout mobile={true} />
    </div>
  {/if}

  {#if user.bio && user.bio != ''}
    <div class="user-bio">
      <Text text={user.bio} editable={false} lines={4} />
    </div>
  {:else}
    <div style="height: 10px" />
  {/if}
  {#if user.spotlight_active}
    <button
      class="creator-spotlight-button"
      on:click={() => {
        showCreatorSpotlightModal = true;
      }}>
      <span>More about me</span>
      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.67383 1.06486C3.40866 1.4361 3.45165 1.98784 3.76986 2.29721L7.57846 6L3.76986 9.70279C3.45165 10.0122 3.40866 10.5639 3.67383 10.9351C3.93901 11.3064 4.41193 11.3565 4.73014 11.0472L9.23014 6.67219C9.40113 6.50595 9.5 6.25968 9.5 6C9.5 5.74032 9.40113 5.49405 9.23014 5.32781L4.73014 0.952828C4.41193 0.64346 3.93901 0.693619 3.67383 1.06486Z"
          fill="#7F7F7F" />
      </svg>
    </button>
  {/if}
  {#if showProfileSearchBar}
    <div style="margin-top: {user.bio && user.bio != '' ? '32px' : '22px'}">
      <UserSearchBar focus={false} user={user} />
    </div>
  {/if}
  <div
    class="panel-user-name-and-add-button"
    class:hidden={userBlocked}
    class:panel-user-add-no-collections={groupCollections.length <= 1}
    style={groups.length == 0 ? 'max-width: unset' : 'max-width: 300px'}>
    <div class="panel-user-name">
      <span class="panel-name"
        >{user.name}{user.name && user.name[user.name.length - 1].toLowerCase() === 's' ? "' Lists" : "'s Lists"}</span>
      {#if !loading && browser && $allProfileGroupsLoaded}
        <span class="panel-count">{groups.length}</span>
      {/if}
    </div>
    <div class="panel-add-button">
      {#if user.permissions.edit}
        <span style={groups.length === 0 ? 'visibility: hidden' : ''}>
          <AddButton
            mobile={true}
            on:added-group={(e) => {
              newGroupCreated(e.detail.group);
            }}
            on:added-collection={(e) => {
              newCollectionCreated(e.detail.collection);
            }} />
        </span>
      {/if}
    </div>
  </div>

  {#if loading}
    <div class="loading-container">
      <PreloadBox />
    </div>
  {:else if userBlocked}
    <BlockedProfileContent user={user} />
  {:else if groups.length === 0 && hasGroupIdeasUser && user.permissions.edit}
    <div class="purple-box" style="background: #fff; border: 1px solid #eae4ff;" on:click={startRecommending}>
      <img src="/images/add-rec-btn.svg" />
      <div class="ui-text-create" style="color: #000; font-size: 18px;">Start recommending</div>
    </div>
  {:else if groups.length === 0}
    <div
      class="purple-box"
      on:click={() => {
        if (user.permissions.edit) {
          jQuery('.add-collection-btn').click();
        }
      }}>
      {#if user.permissions.edit}
        <img src="/images/add-rec-btn.svg" />
        <div class="ui-text-create">Create your first list</div>
      {:else}
        <img src="/images/sparkles.png" />

        <div class="ui-text">
          {user.name} doesn't have any public lists yet
        </div>
      {/if}
    </div>
  {:else}
    <div class="no-scrollbar collection-bar-container">
      <div style="width: {(214 * groupCollections.length + 8 * groupCollections.length) / 2}px">
        <ProfileCollectionBar mobile={true} user={user} />
      </div>
    </div>

    {#each groupCollections as groupCollection (groupCollection.id)}
      {#if user.permissions.edit || groupsStore.findByIds(groupCollection.group_base_sort_order).length > 0}
        <ProfileCollection
          id={groupCollection.id}
          user={user}
          mobile={true}
          on:new-duplicate-created={(e) => {
            newGroupCreated(e.detail.group);
          }}
          on:added-group={(e) => {
            newGroupCreated(e.detail.group, e.detail.collection);
          }} />
      {/if}
    {/each}
  {/if}
  {#if !loading}
    <div use:inview={{}} on:enter={endOfPageReached} />
  {/if}

  <div style="height: 150px" />
</div>
